<template>
  <el-row type="flex" :gutter="20">
    <el-col :span="8" class="left-col-wrapper">
        <div class="page-container-left-col">
          <el-row  class="title-bar">
            <div class="title-h4 title-bar">관리 자원</div>
          </el-row>
          <el-collapse class="collapse-mini" v-model="activeRsctypes">
            <el-collapse-item v-for="rsctype in rsctypeList" :key="rsctype.rsctypeId" :title="rsctype.rsctypeName" :name="rsctype.rsctypeId">
              <ul style="padding-left: 25px;">
                <li style="margin-bottom: 3px; cursor: pointer;" v-for="rsc in getRscList(rsctype.rsctypeId)" :key="`${rsctype.rsctypeId}.${rsc.rscId}`"
                  @click="onClickRsc(rsc)">{{ rsc. rscName }}</li>
              </ul>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-col>
      <el-col :span="16">
        <el-row  class="title-bar" type="flex" justify="space-between">
          <div><div class="title-h4 title-bar">수집 설정 키</div><span v-show="(targetGetdataLabel !== '')" style="padding-left: 10px;">수집 방식 {{targetGetdataLabel}}</span></div>
          <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
        </el-row>
        <el-table-wrapper border :data="tableData" :pagination="false" :columns="tableColumn" :column-default="columnDefault" :show-search-tool="showSearchTool"
          style="width:100%;" header-align="center" :show-custom-header="true">
          <template slot-scope="scope" slot="mapping-value">
            <w-obj-key-setting-value-component :basicinfo-set-list="basicinfoSetList" :target-data="scope.row">
            </w-obj-key-setting-value-component>
          </template>
        </el-table-wrapper>
      </el-col>
  </el-row>
</template>

<script>
import { filter, cloneDeep, differenceWith, isEqual, forEach } from 'lodash';
import { columnDefault } from '@/constants/table';
import { isEmpty } from '@/utils/basic';
import msgUtil from '@/utils/message';
import ChartAPI from '@/api/chart/chart-analysis';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';
import WObjKeySettingValueComponent from './ObjKeySettingValueComponent';

export default {
  name: 'WObjRscKeySettingList',
  components: {
    WObjKeySettingValueComponent,
  },
  props: {
    objInfo: {
      type: Object,
    },
    agentObjId: Number,
    basicinfoSetList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      flag: true,
      treeParamsInfo: {},
      targetGetdataLabel: '',
      activeRsctypes: [],
      rsctypeList: [],
      rscList: [],
      showSearchTool: false,
      tableData: [],
      tableDataOrigin: [],
      columnDefault,
      tableColumn: [
        {
          prop: 'mappingKey',
          label: '설정 키',
          searchable: true,
        },
        {
          prop: 'mappingKeyName',
          label: '설정 키 명',
          searchable: true,
        },
        {
          label: '설정 키 값',
          searchable: true,
          scopedSlot: 'mapping-value',
        },
      ],
    };
  },
  watch: {
    basicinfoSetList: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.loadData();
        });
      },
    },
  },
  methods: {
    loadData() {
      const objInfo = this.objInfo;

      this.rsctypeList = [];
      this.tableData = [];
      this.rscList = [];
      this.targetGetdataLabel = '';
      let params;
      if (!isEmpty(objInfo.rscKey)) {
        params = {
          rscKey: objInfo.rscKey,
          objDefineId: objInfo.obj.objDefineId,
          includeBooleanValue: true,
        };
      } else {
        const obj = objInfo.obj;
        params = {
          objId: obj.objId,
          managetypeId: obj.objManagetypeId,
          objDefineId: obj.objDefineId,
          objtypeId: obj.objtypeId,
          includeBooleanValue: true,
        };
      }
      ChartAPI.getChartRscInfo(params)
        .then((response) => {
          if (response.data.success) {
            const result = response.data.data;
            this.rsctypeList = result.rsctypeList;
            this.rscList = result.rscList;
          }
        });
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    getRscList(rsctypeId) {
      const rscList = this.rscList;
      return filter(rscList, { rsctypeId });
    },
    onSaveButtonClick() {
      const list = differenceWith(this.tableData, this.tableDataOrigin, isEqual);
      const params = {
        list,
        ...this.treeParamsInfo,
      };
      const target = '수집 설정 키';
      const action = msgUtil.action.SAVE;
      RuleSettingsAPI.updateMappingKeyObjRscList(params).then((res) => {
        if (res.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    onClickRsc(item) {
      this.targetGetdataLabel = '';
      // this.tableData = [];
      const params = {
        objId: item.managetypeId === 'E2E' ? this.agentObjId : this.objInfo.obj.objId,
        managetypeId: item.managetypeId,
        rsctypeId: item.rsctypeId,
        rscId: item.rscId,
      };
      // 수집 방식 조회
      RuleSettingsAPI.getRscGetdataOfObjRsc(params).then((res) => {
        if (res.data.success) {
          const data = res.data.data;
          if (res.data.data.rscGetdataTypeId) {
            const targetSourceName = data.sourceName ? data.sourceName : '없음';
            this.targetGetdataLabel = `${data.rscGetmethodName}(${data.rscGetdataTypeName}> ${targetSourceName})`;
          } else {
            this.targetGetdataLabel = `${data.rscGetmethodName}(없음)`;
          }
          params.rscGetmethodId = data.rscGetmethodId;
          params.rscGetdataTypeId = data.rscGetdataTypeId;
          params.sourceId = data.sourceId;
          // 장비 자원의 수집 설정 키 목록을 조회
          RuleSettingsAPI.getMappingKeyObjRscList(params).then((response) => {
            if (response.data.success) {
              this.treeParamsInfo = params;
              this.tableData = response.data.data;
              forEach(this.tableData, (target, index) => {
                if (target.mappingValue && target.datatypeId === 'INTEGER') {
                  this.tableData[index].mappingValue = Number(target.mappingValue);
                }
              });
              this.tableDataOrigin = cloneDeep(this.tableData);
            }
          });
        }
      });
    },
    checkChangeFlag() {
      this.saveFlagRsc = !isEqual(this.tableData, this.tableDataOrigin);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ObjRscKeySettingList.vue